export const minBy = (collection, key) => {
    const select = (a, b) => a[key] <= b[key] ? a : b
    return collection.reduce(select, {})
}

export const maxBy = (collection, key) => {
    const select = (a, b) => a[key] >= b[key] ? a : b
    return collection.reduce(select, {})
}

export const uniqBy = (collection: any[], fn: (a: any, b: any) => boolean) => collection.filter((element, index) => collection.findIndex((step) => fn(element, step)) === index);

export const areSame = (a: any[], b: any[]): boolean => {
    const setA = new Set(a);
    const setB = new Set(b);
    return setA.size === setB.size && a.every(item => setB.has(item));
}

export const sortBy = (key) => {
    return (a, b) => {
        const getValue = (obj, path) => path.split('.').reduce((acc, part) => acc && acc[part], obj);
        const valA = getValue(a, key);
        const valB = getValue(b, key);

        return valA > valB ? 1 : valA > valB ? -1 : 0;
    };
};

export const sortByDesc = (key) => {
    return (a, b) => {
        const getValue = (obj, path) => path.split('.').reduce((acc, part) => acc && acc[part], obj);
        const valA = getValue(a, key);
        const valB = getValue(b, key);

        return valA < valB ? 1 : valA > valB ? -1 : 0;
    };
};
